<template>
  <svg width="230px" height="230px" viewBox="0 0 230 230" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle data-id="1" class="wheel__segment segment__1" cx="115" cy="115" r="115" fill="#E8560E"/>
    <path  class="index-module-1" d="M115.359 212H117.087V199.256H115.557L112.011 202.19L113.019 203.396L115.359 201.236V212Z" fill="white"/>
  </svg>
</template>